<template>
	<v-card>
		<v-card-title class="py-2 primary">
			<span class="tertiary--text">Note Accordo</span>
		</v-card-title>
		<v-card-text class="pt-6">
			<v-row>
				<v-col>
					<v-textarea
						outlined
						class="mt-1"
						:value="accordo.notes"
						@input="accordo.notes = $event !== '' ? $event : null"
					></v-textarea>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				@click="close()"
				:disabled="isSaving"
				class="black--text"
			>
				{{ accordo.notes !== backupAccordo.notes ? 'Annulla' : 'Chiudi' }}
			</v-btn>
			<v-btn
				color="secondary"
				@click="update()"
				:disabled="isSaving || accordo.notes === backupAccordo.notes"
				:loading="isSaving"
			>
				Salva
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {eventBus} from '@/event-bus';
export default {
	props: {
		value: {
			default: null
		},
	}, // pratica object
	data() {
		return {
			backupAccordo: null,
			accordo: {
				id: null,
				custom_id: null,
				cliente: {
					ragione_sociale: null,
				},
				notes: null
			},
			isSaving: false
		}
	},
	
	created() {
		this.backupAccordo = Object.assign({}, this.value);
		this.accordo = Object.assign({}, this.value);
	},
	
	methods: {
		update() {
			this.isSaving = true;
			let accordo = {
				id: this.accordo.id,
				notes: this.accordo.notes
			}
			let formData = new FormData();
			formData.append('accordo', JSON.stringify(accordo));
			axios.patch(`/api/accordi/${accordo.id}`, formData, {
				headers: { 'Content-Type': 'multipart/form-data' }
			})
				.then(response => {
					this.$emit('accordo-updated', {
						accordoAggiornato: response.data
					})
					this.close();
				})
				.finally(() => {
					this.isSaving = false;
				})
		},
		close() {
			this.$emit('close');
		}
	}
}
</script>